(function () {
  var STARTER_HANDLE = 'haro-clear-starter-kit';
  var POUCH_45_HANDLE = 'haro-clear-refill-pouch-45-day';
  var REFILL_SUBSCRIBE_HANDLE = 'haro-clear-refill-pouch-90-day-supply-sands';
  var META_STARTER_HANDLE = 'meta-haro-clear-starter-kit-90-day-eye-health-supply';
  var META_POUCH_45_HANDLE = 'meta-haro-clear-refill-pouch-45-day-supply-eye-health-supplement-90-capsules';
  var META_REFILL_SUBSCRIBE_HANDLE = 'haro-clear-refill-pouch-90-day-supply-eye-health-supplement-180-capsules-meta';
  var CRAZY_SALE_POPUP_SESSION_KEY = 'haro_crazy_sale_popup_seen_v3';
  var CRAZY_SALE_POPUP_DISMISS_UNTIL_KEY = 'haro_crazy_sale_popup_dismissed_until_v1';
  var CRAZY_SALE_POPUP_COUNTDOWN_SECONDS = 5;
  var MAX_QTY = 40;
  var MAX_QTY_TOOLTIP_TEXT = 'Maximum 40 units per order.';
  var MAX_CART_TOOLTIP_TEXT = 'Carts are maxed at 40 items. Please remove items before adding more.';
  var USD_CENTS_BY_HANDLE = {};
  USD_CENTS_BY_HANDLE[STARTER_HANDLE] = 8495;
  USD_CENTS_BY_HANDLE[META_STARTER_HANDLE] = 8495;
  USD_CENTS_BY_HANDLE[POUCH_45_HANDLE] = 3995;
  USD_CENTS_BY_HANDLE[META_POUCH_45_HANDLE] = 3995;
  USD_CENTS_BY_HANDLE[REFILL_SUBSCRIBE_HANDLE] = 7191;
  USD_CENTS_BY_HANDLE[META_REFILL_SUBSCRIBE_HANDLE] = 7191;

  var DISPLAY_TITLE_BY_HANDLE = {};
  DISPLAY_TITLE_BY_HANDLE[STARTER_HANDLE] = 'Haro Clear Starter Kit – 90 Day Eye Health Supply';
  DISPLAY_TITLE_BY_HANDLE[META_STARTER_HANDLE] = 'Haro Clear Starter Kit – 90 Day Eye Health Supply';
  DISPLAY_TITLE_BY_HANDLE[POUCH_45_HANDLE] = 'Haro Clear Refill Pouch – 45-Day Supply (90 Capsules)';
  DISPLAY_TITLE_BY_HANDLE[META_POUCH_45_HANDLE] = 'Haro Clear Refill Pouch – 45-Day Supply (90 Capsules)';
  DISPLAY_TITLE_BY_HANDLE[REFILL_SUBSCRIBE_HANDLE] = 'Subscribe & Save: 2 Refill Pouches Every 90 Days';
  DISPLAY_TITLE_BY_HANDLE[META_REFILL_SUBSCRIBE_HANDLE] = 'Subscribe & Save: 2 Refill Pouches Every 90 Days';

  var moneyFormatContext = {
    currencyCode: null,
    locale: null
  };

  function parseBooleanFlag(value) {
    var normalized = String(value == null ? '' : value).trim().toLowerCase();
    return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
  }

  function getInitialSelectionFromUrl(defaultTab) {
    var normalizedDefaultTab = String(defaultTab || '').toLowerCase() === 'pouches' ? 'pouches' : 'starter';
    var result = {
      tab: normalizedDefaultTab,
      subscribe: false,
      hasTabOverride: false
    };

    try {
      var params = new URLSearchParams(window.location.search || '');
      var tab = (params.get('haro_tab') || '').trim().toLowerCase();
      var subscribeRaw = params.get('haro_subscribe');

      if (tab === 'pouches' || tab === 'starter') {
        result.tab = tab;
        result.hasTabOverride = true;
      }

      if (subscribeRaw != null) {
        result.subscribe = parseBooleanFlag(subscribeRaw);
      }

      if ((window.location.hash || '').toLowerCase().indexOf('refill-pouches') >= 0) {
        result.tab = 'pouches';
        result.hasTabOverride = true;
      }

      if (result.subscribe) {
        result.tab = 'pouches';
        result.hasTabOverride = true;
      }
    } catch (error) {}

    return result;
  }

  function formatMoney(cents) {
    var value = Number(cents || 0);
    var amount = value / 100;
    var currencyCode = moneyFormatContext.currencyCode
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      || 'USD';
    var locale = moneyFormatContext.locale || document.documentElement.lang || undefined;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {}

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value);
    }
    return amount.toFixed(2) + ' ' + String(currencyCode);
  }

  function formatMoneyWhole(cents) {
    var value = Number(cents || 0);
    var amount = Math.round(value / 100);
    var currencyCode = moneyFormatContext.currencyCode
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      || 'USD';
    var locale = moneyFormatContext.locale || document.documentElement.lang || undefined;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (error) {}

    var roundedCents = amount * 100;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(roundedCents);
    }
    return String(amount) + ' ' + String(currencyCode);
  }

  function percentOff(currentPrice, comparePrice) {
    var current = Number(currentPrice || 0);
    var compare = Number(comparePrice || 0);
    if (!Number.isFinite(current) || !Number.isFinite(compare) || compare <= 0 || current >= compare) return 0;
    return Math.round(((compare - current) / compare) * 100);
  }

  function stripHtml(html) {
    var div = document.createElement('div');
    div.innerHTML = html || '';
    return (div.textContent || div.innerText || '').trim();
  }

  function firstAvailableVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    return product.variants.find(function (v) { return v.available; }) || product.variants[0];
  }

  function toShortText(text, limit) {
    var value = String(text || '').trim();
    if (value.length <= limit) return value;
    return value.slice(0, limit).trim() + '...';
  }

  function normalizeDisplayTitle(title) {
    var value = String(title || '').trim();
    if (!value) return '';
    value = value
      .replace(/^meta\s*[-–—:]\s*/i, '')
      .replace(/^meta\s+/i, '')
      .replace(/\s*[-–—:]?\s*eye health supplement\b/ig, '')
      .replace(/\b90\s*-\s*day\b/ig, '90 Day')
      .replace(/\s{2,}/g, ' ')
      .trim();

    if (/starter kit/i.test(value) && !/90[-\s]?day/i.test(value)) {
      value += ' - 90 Day Supply';
    }

    return value;
  }

  function productDisplayTitle(product) {
    var handle = product && product.handle;
    return DISPLAY_TITLE_BY_HANDLE[handle] || normalizeDisplayTitle(product && product.title) || '';
  }

  function resolveImageUrl(imageLike) {
    if (!imageLike) return '';
    if (typeof imageLike === 'string') return imageLike;
    return imageLike.src || imageLike.url || '';
  }

  function withImageWidth(url, width) {
    var value = String(url || '');
    if (!value || value.indexOf('cdn.shopify.com') === -1) return value;
    var normalized = value
      .replace(/([?&])width=\d+/g, '$1')
      .replace(/([?&])quality=\d+/g, '$1')
      .replace(/([?&])format=[a-zA-Z0-9]+/g, '$1')
      .replace(/[?&]$/, '');
    var sep = normalized.indexOf('?') === -1 ? '?' : '&';
    return normalized + sep + 'width=' + String(width) + '&format=webp&quality=80';
  }

  function productPrimaryImage(product, width) {
    var fromFeatured = resolveImageUrl(product && product.featured_image);
    var fromImages = Array.isArray(product && product.images) && product.images.length
      ? resolveImageUrl(product.images[0])
      : '';
    var raw = fromFeatured || fromImages;
    return withImageWidth(raw, width || 160);
  }

  function clampQtyValue(raw) {
    var parsed = parseInt(raw, 10);
    if (!Number.isFinite(parsed)) return 1;
    return Math.min(MAX_QTY, Math.max(1, parsed));
  }

  function preloadImage(url) {
    if (!url) return;
    var img = new Image();
    img.decoding = 'async';
    img.loading = 'eager';
    img.src = url;
  }

  function marketingFallbackPercent(handle, isMetaFlow, isSubscribedPouches) {
    if (!handle) return 0;

    if (isMetaFlow) {
      if (handle === STARTER_HANDLE || handle === META_STARTER_HANDLE) return 43;
      if (handle === POUCH_45_HANDLE || handle === META_POUCH_45_HANDLE) return 44;
      if (
        handle === REFILL_SUBSCRIBE_HANDLE
        || handle === META_REFILL_SUBSCRIBE_HANDLE
        || isSubscribedPouches
      ) return 49;
      return 0;
    }

    // Standard flow targets.
    if (handle === STARTER_HANDLE) return 26;
    if (handle === POUCH_45_HANDLE) return 27;
    if (handle === REFILL_SUBSCRIBE_HANDLE || isSubscribedPouches) return 35;
    return 0;
  }

  function fallbackCompareFromPercent(unitPrice, percent) {
    var unit = Number(unitPrice || 0);
    var pct = Number(percent || 0);
    if (!Number.isFinite(unit) || unit <= 0 || !Number.isFinite(pct) || pct <= 0 || pct >= 100) return 0;
    return Math.round(unit / (1 - (pct / 100)));
  }

  function standardSubscribeCompareFromAnchor(unitPrice) {
    var unit = Number(unitPrice || 0);
    // Standard flow business rule:
    // discounted subscription price is anchored to USD 71.91 and
    // original 2-pouch reference price is USD 109.70.
    // We keep the same ratio in presentment currencies.
    var DISCOUNTED_USD_CENTS = 7191;
    var ORIGINAL_USD_CENTS = 10970;
    if (!Number.isFinite(unit) || unit <= 0) return 0;
    return Math.round(unit * (ORIGINAL_USD_CENTS / DISCOUNTED_USD_CENTS));
  }

  function syncMainProductGallery(scopeEl, product) {
    if (!scopeEl || !product) return;

    var productInfo = scopeEl.closest('product-info') || document;
    var slidesContainer = productInfo.querySelector('[data-product-media-list]');
    if (!slidesContainer) return;

    var productImages = productInfo.querySelector('product-images');
    var thumbsHolder = productInfo.querySelector('[data-thumbs-slider]');
    var imageUrls = [];

    if (Array.isArray(product.images)) {
      imageUrls = product.images.filter(Boolean).map(function (img) {
        return typeof img === 'string' ? img : (img.src || img.url || '');
      }).filter(Boolean);
    }

    if (!imageUrls.length && Array.isArray(product.media)) {
      imageUrls = product.media
        .map(function (m) {
          if (!m) return '';
          if (m.preview_image && (m.preview_image.src || m.preview_image.url)) {
            return m.preview_image.src || m.preview_image.url;
          }
          return m.src || m.url || '';
        })
        .filter(Boolean);
    }

    if (!imageUrls.length && product.featured_image) {
      imageUrls = [product.featured_image];
    }
    if (!imageUrls.length) return;

    var slideNodes = Array.prototype.slice.call(slidesContainer.querySelectorAll('.product__slide'));
    if (!slideNodes.length) return;

    slideNodes.forEach(function (slideNode, idx) {
      var hasImage = idx < imageUrls.length;
      var url = hasImage ? imageUrls[idx] : '';
      var img = slideNode.querySelector('img');
      var sources = slideNode.querySelectorAll('source');

      slideNode.style.display = hasImage ? '' : 'none';
      slideNode.classList.toggle('media--active', hasImage && idx === 0);
      slideNode.classList.toggle('media--hidden', !hasImage || idx !== 0);

      if (img && hasImage) {
        img.src = url;
        img.alt = productDisplayTitle(product);
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.setAttribute('loading', idx === 0 ? 'eager' : 'lazy');
      }
      if (hasImage && sources && sources.length) {
        sources.forEach(function (source) {
          source.srcset = url;
        });
      }
    });

    if (thumbsHolder) {
      var thumbNodes = Array.prototype.slice.call(thumbsHolder.querySelectorAll('[data-thumb-item]'));
      thumbNodes.forEach(function (thumbNode, idx) {
        var hasImage = idx < imageUrls.length;
        var url = hasImage ? imageUrls[idx] : '';
        var link = thumbNode.querySelector('[data-thumb-link]');
        var img = thumbNode.querySelector('img');
        var sources = thumbNode.querySelectorAll('source');

        thumbNode.style.display = hasImage ? '' : 'none';
        thumbNode.classList.toggle('is-active', hasImage && idx === 0);
        if (link) {
          link.setAttribute('aria-current', hasImage && idx === 0 ? 'true' : 'false');
          if (hasImage) link.href = url;
        }
        if (img && hasImage) {
          img.src = url;
          img.alt = productDisplayTitle(product);
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
        }
        if (hasImage && sources && sources.length) {
          sources.forEach(function (source) {
            source.srcset = url;
          });
        }
      });
    }

    if (productImages) {
      var activeSlide = slideNodes.find(function (node) {
        return node.style.display !== 'none' && node.classList.contains('media--active');
      }) || slideNodes[0];
      if (activeSlide && activeSlide.getAttribute('data-media-id')) {
        productImages.setAttribute('data-active-media', activeSlide.getAttribute('data-media-id'));
      }
    }
  }

  function initMegaPdp(root) {
    if (!root || root.dataset.megaBound === '1') return;
    root.dataset.megaBound = '1';
    moneyFormatContext.currencyCode = root.dataset.currencyCode
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      || null;
    moneyFormatContext.locale = document.documentElement.lang || null;
    var productInfoEl = root.closest('product-info');
    var masterWrapperEl = productInfoEl ? productInfoEl.closest('.product__wrapper') : null;
    var masterPageEl = productInfoEl ? productInfoEl.closest('.product__page') : null;
    if (document && document.body) document.body.classList.add('haro-master-active');
    if (productInfoEl) productInfoEl.classList.add('haro-master-product-info');
    if (masterWrapperEl) masterWrapperEl.classList.add('haro-master-wrapper');
    if (masterPageEl) masterPageEl.classList.add('haro-master-page');

    var tabButtons = Array.prototype.slice.call(root.querySelectorAll('[data-mega-tab]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mega-card="true"][data-product-handle]'));
    var qtyInput = root.querySelector('[data-mega-qty]');
    var qtyMinus = root.querySelector('[data-mega-qty-minus]');
    var qtyPlus = root.querySelector('[data-mega-qty-plus]');
    var qtyTooltip = root.querySelector('[data-mega-qty-tooltip]');
    var atcButton = root.querySelector('[data-mega-atc]');
    var actionsEl = root.querySelector('.haro-mega-actions');
    var metaStickyEl = root.querySelector('[data-mega-meta-sticky]');
    var metaStickyLabelEl = root.querySelector('[data-mega-meta-sticky-label]');
    var metaStickyPriceEl = root.querySelector('[data-mega-meta-sticky-price]');
    var metaStickyAtcEl = root.querySelector('[data-mega-meta-sticky-atc]');
    var imageEl = root.querySelector('[data-mega-image]');
    var titleEl = root.querySelector('[data-mega-title]');
    var priceEl = root.querySelector('[data-mega-price]');
    var subtitleEl = root.querySelector('[data-mega-subtitle]');
    var purchaseOptionsEl = root.querySelector('[data-mega-purchase-options]');
    var purchasePriceRowEl = root.querySelector('.haro-mega-purchase__price');
    var sellingPlanInputEl = root.querySelector('[data-mega-selling-plan-input]');
    var activePriceEl = root.querySelector('[data-mega-active-price]');
    var comparePriceEl = root.querySelector('[data-mega-compare-price]');
    var discountBadgeEl = root.querySelector('[data-mega-discount-badge]');
    var usFreeShippingEl = root.querySelector('[data-mega-us-free-shipping]');
    var salePopupEl = root.querySelector('[data-mega-sale-popup]');
    var salePopupCloseEls = Array.prototype.slice.call(root.querySelectorAll('[data-mega-sale-popup-close]'));
    var salePopupCtaEl = root.querySelector('[data-mega-sale-popup-cta]');
    var salePopupCountdownEl = root.querySelector('[data-mega-sale-popup-countdown]');
    var salePopupGifEl = root.querySelector('[data-mega-sale-popup-gif]');
    var merchantPrimaryTitleEl = root.querySelector('[data-merchant-primary-title]');
    var merchantPrimaryPriceEl = root.querySelector('[data-merchant-primary-price]');
    var merchantPrimaryAvailabilityEl = root.querySelector('[data-merchant-primary-availability]');

    var starterOneTimeNoteEl = root.querySelector('[data-mega-starter-one-time-note]');
    var starterUpsellWrapEl = root.querySelector('[data-mega-starter-upsell-wrap]');
    var starterUpsellCheckboxEl = root.querySelector('[data-mega-starter-upsell-checkbox]');
    var goRefillLinkEl = root.querySelector('[data-mega-go-refill]');
    var giftsEl = root.querySelector('[data-haro-gifts]');
    var refillSubscribeWrapEl = root.querySelector('[data-mega-refill-subscribe-wrap]');
    var refillSubscribeRowEl = root.querySelector('[data-mega-refill-subscribe-row]');
    var refillSubscribeCheckboxEl = root.querySelector('[data-mega-refill-subscribe-checkbox]');
    var hkPouchNoteEl = root.querySelector('[data-mega-hk-pouch-note]');

    var subscriptionDetailsEl = root.querySelector('[data-mega-subscription-details]');
    var subscriptionDetailsContentEl = root.querySelector('[data-mega-subscription-content]');
    var subscriptionDetailsToggleEl = root.querySelector('[data-mega-subscription-toggle]');
    var subscriptionPriceValueEl = root.querySelector('[data-mega-subscription-price]');
    var giftValueEls = Array.prototype.slice.call(root.querySelectorAll('[data-mega-gift-value][data-gift-cents]'));
    var qtyTooltipTimer = null;

    var state = {
      products: {},
      activeTab: 'starter',
      selectedHandle: null,
      selectedVariantId: null,
      selectedSellingPlanId: null,
      selectedRequiresSellingPlan: false,
      selectedOneTimePrice: 0,
      selectedCompareAtPrice: 0,
      isSubscribed: false
    };
    var hasAttemptedPopupShow = false;
    var salePopupCountdownTimer = null;
    var salePopupAutoMinimizeTimer = null;
    var salePopupCountdownSeconds = CRAZY_SALE_POPUP_COUNTDOWN_SECONDS;
    var salePopupCtaDefaultLabel = salePopupCtaEl ? String((salePopupCtaEl.textContent || '')).trim() : 'Shop The Deal';

    function setSalePopupCtaLabel(countdownText) {
      if (!salePopupCtaEl) return;
      if (!countdownText) {
        salePopupCtaEl.textContent = salePopupCtaDefaultLabel;
        return;
      }

      salePopupCtaEl.textContent = '';
      var main = document.createElement('span');
      main.className = 'haro-sale-popup__cta-main';
      main.textContent = salePopupCtaDefaultLabel;

      var sub = document.createElement('span');
      sub.className = 'haro-sale-popup__cta-countdown';
      sub.textContent = countdownText;

      salePopupCtaEl.appendChild(main);
      salePopupCtaEl.appendChild(sub);
    }

    var isMetaFlow = false;
    var isSimpleOfferFlow = String(root.dataset.isSimpleOfferFlow || '').toLowerCase() === 'true';
    var isMetaSimpleMode = isMetaFlow || isSimpleOfferFlow;
    var isMetaVisitor = false;
    if (isMetaSimpleMode && metaStickyEl && document && document.body) {
      document.body.classList.add('haro-meta-sticky-active');
    }

    var starterHandle = root.dataset.starterHandle || (isMetaFlow ? META_STARTER_HANDLE : STARTER_HANDLE);
    var pouch45Handle = root.dataset.pouch45Handle || (isMetaFlow ? META_POUCH_45_HANDLE : POUCH_45_HANDLE);
    var starterUpsellHandle = root.dataset.starterUpsellHandle || pouch45Handle;
    var refillSubscribeHandle = root.dataset.refillSubscribeHandle || (isMetaFlow ? META_REFILL_SUBSCRIBE_HANDLE : REFILL_SUBSCRIBE_HANDLE);
    var liquidSaysHk = String(root.dataset.isHkMarket || '').toLowerCase() === 'true';
    var activeCurrencyCode = String(
      root.dataset.currencyCode
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      || ''
    ).toUpperCase();
    var shopifyCountry = String((window.Shopify && window.Shopify.country) || '').toUpperCase();
    var shopifyLocale = String((window.Shopify && window.Shopify.locale) || '').toLowerCase();
    var pageLang = String(document.documentElement.lang || '').toLowerCase();
    var pathLower = String(window.location.pathname || '').toLowerCase();
    var runtimeSaysHk = activeCurrencyCode === 'HKD'
      || shopifyCountry === 'HK'
      || shopifyLocale.indexOf('hk') >= 0
      || pageLang.indexOf('hk') >= 0
      || pathLower.indexOf('/en-hk') === 0
      || pathLower.indexOf('/zh-hk') === 0;
    var isHkMarket = liquidSaysHk || runtimeSaysHk;
    root.dataset.runtimeHkMarket = isHkMarket ? 'true' : 'false';
    var hkDistributorMailto = String(root.dataset.hkDistributorMailto || '').trim();

    function escapeHtmlAttr(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function isPouchHandle(handle) {
      return handle === pouch45Handle || handle === refillSubscribeHandle;
    }

    function shouldShowHkDistributorMessage(handle) {
      return isHkMarket && isPouchHandle(handle);
    }

    function hkPricePlaceholderHtml() {
      return '<span class="haro-mega-card__price-current"></span>';
    }

    function scrubLegacyHkDistributorCopy() {
      if (!isHkMarket) return;
      var legacyPattern = /please\s*contact\s*local\s*distributor/i;

      if (activePriceEl && legacyPattern.test(String(activePriceEl.textContent || ''))) {
        activePriceEl.textContent = '';
      }
      if (priceEl && legacyPattern.test(String(priceEl.textContent || ''))) {
        priceEl.textContent = '';
      }

      cards.forEach(function (card) {
        var cardPrice = card.querySelector('[data-card-price]');
        if (!cardPrice) return;
        if (legacyPattern.test(String(cardPrice.textContent || ''))) {
          cardPrice.innerHTML = hkPricePlaceholderHtml();
        }
      });
    }

    function syncHkPouchDisabledUi(isDisabled) {
      if (actionsEl) actionsEl.classList.toggle('is-disabled', !!isDisabled);
      if (qtyMinus) qtyMinus.disabled = !!isDisabled;
      if (qtyPlus) qtyPlus.disabled = !!isDisabled;
      if (qtyInput) qtyInput.disabled = !!isDisabled;
      if (metaStickyAtcEl) {
        metaStickyAtcEl.disabled = !!isDisabled;
        metaStickyAtcEl.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      }
    }

    function syncHkPouchMessage(isVisible) {
      if (!hkPouchNoteEl) return;
      hkPouchNoteEl.hidden = !isVisible;
    }

    function renderCardPrice(cardPrice, handle, unitPrice, comparePrice) {
      if (!cardPrice) return;
      if (shouldShowHkDistributorMessage(handle)) {
        cardPrice.innerHTML = hkPricePlaceholderHtml();
        return;
      }

      if (comparePrice > unitPrice) {
        var badgeText = percentOff(unitPrice, comparePrice) + '% OFF';
        cardPrice.innerHTML = ''
          + '<span class="haro-mega-card__price-current">' + formatMoney(unitPrice) + '</span>'
          + '<span class="haro-mega-card__price-compare">' + formatMoney(comparePrice) + '</span>'
          + '<span class="haro-mega-card__price-badge">' + badgeText + '</span>';
      } else {
        cardPrice.textContent = formatMoney(unitPrice);
      }
    }

    function debugEnabled() {
      return !!((window.Shopify && window.Shopify.designMode) || window.__HARO_DEBUG_MEGA_PDP);
    }

    function subscriptionDebugEnabled() {
      try {
        var params = new URLSearchParams(window.location.search || '');
        return params.get('haro_debug_sub') === '1' || window.__HARO_DEBUG_SUBSCRIPTION === true;
      } catch (error) {
        return window.__HARO_DEBUG_SUBSCRIPTION === true;
      }
    }

    function debugSubscription(label, payload) {
      if (!subscriptionDebugEnabled()) return;
      try {
        console.info('[HARO_SUB_DEBUG] ' + label, payload);
      } catch (error) {}
    }

    function setSubscriptionDetailsExpanded(isExpanded) {
      if (!subscriptionDetailsContentEl || !subscriptionDetailsToggleEl) return;
      subscriptionDetailsContentEl.classList.toggle('is-expanded', isExpanded);
      subscriptionDetailsContentEl.classList.toggle('is-collapsed', !isExpanded);
      subscriptionDetailsToggleEl.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      subscriptionDetailsToggleEl.textContent = isExpanded ? 'Show less' : 'Show more';
    }

    function refreshSubscriptionDetailsOverflow() {
      if (!subscriptionDetailsContentEl || !subscriptionDetailsToggleEl || !subscriptionDetailsEl || subscriptionDetailsEl.hidden) return;

      var wasExpanded = subscriptionDetailsContentEl.classList.contains('is-expanded');
      subscriptionDetailsContentEl.classList.remove('is-expanded');
      subscriptionDetailsContentEl.classList.add('is-collapsed');

      var hasOverflow = subscriptionDetailsContentEl.scrollHeight > subscriptionDetailsContentEl.clientHeight + 2;
      subscriptionDetailsToggleEl.hidden = !hasOverflow;

      if (hasOverflow) {
        setSubscriptionDetailsExpanded(wasExpanded);
      } else {
        setSubscriptionDetailsExpanded(false);
      }
    }

    function parseJsonResponseSafe(response) {
      return response.text().then(function (raw) {
        var text = (raw || '').trim();
        if (!text) {
          throw new Error('Add to cart failed (' + response.status + ' ' + response.statusText + '): empty response body');
        }

        var looksJson = text[0] === '{' || text[0] === '[';
        if (!looksJson) {
          throw new Error('Add to cart failed (' + response.status + ' ' + response.statusText + '): non-JSON response: ' + text.slice(0, 240));
        }

        var data;
        try {
          data = JSON.parse(text);
        } catch (error) {
          throw new Error('Add to cart failed (' + response.status + ' ' + response.statusText + '): invalid JSON response');
        }

        if (!response.ok || data.status) {
          var message = data.description || data.message || 'Unknown cart error';
          throw new Error('Add to cart failed (' + response.status + ' ' + response.statusText + '): ' + message);
        }

        return data;
      });
    }

    function showQtyLimitTooltip(message) {
      if (!qtyTooltip) return;
      qtyTooltip.textContent = String(message || MAX_QTY_TOOLTIP_TEXT);
      qtyTooltip.hidden = false;
      qtyTooltip.classList.add('is-visible');
      if (qtyTooltipTimer) {
        window.clearTimeout(qtyTooltipTimer);
      }
      qtyTooltipTimer = window.setTimeout(function () {
        qtyTooltip.classList.remove('is-visible');
        qtyTooltip.hidden = true;
      }, 2200);
    }

    function getCartJsonSafe() {
      return fetch('/cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        return response.text().then(function (raw) {
          var text = (raw || '').trim();
          if (!text) {
            throw new Error('Cart refresh failed (' + response.status + ' ' + response.statusText + '): empty response body');
          }

          var looksJson = text[0] === '{' || text[0] === '[';
          if (!looksJson) {
            throw new Error('Cart refresh failed (' + response.status + ' ' + response.statusText + '): non-JSON response: ' + text.slice(0, 240));
          }

          var data;
          try {
            data = JSON.parse(text);
          } catch (error) {
            throw new Error('Cart refresh failed (' + response.status + ' ' + response.statusText + '): invalid JSON response');
          }

          if (!response.ok) {
            var message = data.description || data.message || response.statusText || 'Unknown cart error';
            throw new Error('Cart refresh failed (' + response.status + ' ' + response.statusText + '): ' + message);
          }

          return data;
        });
      });
    }

    function cartItemCount(cart) {
      if (!cart || !Array.isArray(cart.items)) return 0;
      return cart.items.reduce(function (total, item) {
        return total + Math.max(0, Number(item && item.quantity || 0));
      }, 0);
    }

    function hydrateCard(cardEl) {
      if (!cardEl) return false;
      var handle = cardEl.dataset.productHandle;
      var product = state.products[handle];
      if (!product) return false;
      var variant = firstAvailableVariant(product);
      if (!variant) return false;

      var cardTitle = cardEl.querySelector('[data-card-title]');
      var cardPrice = cardEl.querySelector('[data-card-price]');
      var cardDesc = cardEl.querySelector('[data-card-desc]');
      var cardImage = cardEl.querySelector('[data-card-image]');
      var description = toShortText(stripHtml(product.description), 90);
      var imageUrl = productPrimaryImage(product, 160);

      if (cardTitle) cardTitle.textContent = productDisplayTitle(product);
      if (cardPrice) {
        var unitPrice = Number(variant.price || 0);
        var comparePrice = Number(variant.compare_at_price || 0);
        var isStandardSubscribeCard = !isMetaFlow && handle === REFILL_SUBSCRIBE_HANDLE;
        var shouldForceFallbackCompare = !isMetaFlow
          && (handle === STARTER_HANDLE || handle === POUCH_45_HANDLE || handle === REFILL_SUBSCRIBE_HANDLE);
        var fallbackPercent = marketingFallbackPercent(
          handle,
          isMetaFlow,
          state.activeTab === 'pouches' && state.isSubscribed
        );
        var compareFallback = fallbackCompareFromPercent(unitPrice, fallbackPercent);
        if (isStandardSubscribeCard) {
          var anchorCompare = standardSubscribeCompareFromAnchor(unitPrice);
          if (anchorCompare > unitPrice) compareFallback = anchorCompare;
        }
        if (shouldForceFallbackCompare && compareFallback > unitPrice) {
          comparePrice = compareFallback;
        } else if (comparePrice <= unitPrice && compareFallback > unitPrice) {
          comparePrice = compareFallback;
        }
        renderCardPrice(cardPrice, handle, unitPrice, comparePrice);
      }
      if (cardDesc) cardDesc.textContent = description;
      if (cardImage && imageUrl) {
        cardImage.src = imageUrl;
        cardImage.alt = productDisplayTitle(product);
        cardImage.loading = 'eager';
        cardImage.fetchPriority = 'high';
        cardImage.decoding = 'async';
      }
      return true;
    }

    function findSelectedVariantData() {
      if (!state.selectedHandle || !state.selectedVariantId) return null;
      var product = state.products[state.selectedHandle];
      if (!product || !product.variants || !product.variants.length) return null;
      var selectedId = Number(state.selectedVariantId);
      return product.variants.find(function (v) { return Number(v.id) === selectedId; }) || null;
    }

    function firstSellingPlanIdForVariant(variant, product) {
      if (variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
        var first = variant.selling_plan_allocations[0];
        if (first && first.selling_plan_id) return String(first.selling_plan_id);
      }

      if (product && product.selling_plan_groups && product.selling_plan_groups.length) {
        for (var i = 0; i < product.selling_plan_groups.length; i += 1) {
          var group = product.selling_plan_groups[i];
          if (group && group.selling_plans && group.selling_plans.length) {
            var plan = group.selling_plans[0];
            if (plan && plan.id) return String(plan.id);
          }
        }
      }

      return null;
    }

    function findSellingPlanAllocation(variant, sellingPlanId) {
      if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) return null;
      if (!sellingPlanId) return variant.selling_plan_allocations[0] || null;
      var targetId = String(sellingPlanId);
      return variant.selling_plan_allocations.find(function (allocation) {
        return String(allocation && allocation.selling_plan_id) === targetId;
      }) || variant.selling_plan_allocations[0] || null;
    }

    function allocationPriceValue(allocation, fallback) {
      if (!allocation) return Number(fallback || 0);
      var raw = allocation.price;
      if (raw == null) raw = allocation.per_delivery_price;
      if (raw == null) raw = allocation.checkout_charge_amount;
      var value = Number(raw);
      return Number.isFinite(value) ? value : Number(fallback || 0);
    }

    function allocationComparePriceValue(allocation, fallback) {
      if (!allocation) return Number(fallback || 0);
      var raw = allocation.compare_at_price;
      if (raw == null) raw = allocation.price_compare;
      var value = Number(raw);
      return Number.isFinite(value) ? value : Number(fallback || 0);
    }

    function refreshSelectedPricesForMode() {
      var selectedVariant = findSelectedVariantData();
      if (!selectedVariant) return;

      var basePrice = Number(selectedVariant.price || 0);
      var baseCompare = Number(selectedVariant.compare_at_price || 0);
      var unitPrice = basePrice;
      var comparePrice = baseCompare;

      var isSubscribedPouchesMode = !isMetaSimpleMode && state.activeTab === 'pouches' && state.isSubscribed;
      if (isSubscribedPouchesMode) {
        var allocation = findSellingPlanAllocation(selectedVariant, state.selectedSellingPlanId);
        unitPrice = allocationPriceValue(allocation, basePrice);
        comparePrice = allocationComparePriceValue(allocation, baseCompare);
      }

      var selectedHandleForFallback = state.selectedHandle || activeHandleForMode();
      var fallbackPercent = marketingFallbackPercent(
        selectedHandleForFallback,
        isMetaFlow,
        isSubscribedPouchesMode
      );
      var compareFallback = fallbackCompareFromPercent(unitPrice, fallbackPercent);
      var isStandardSubscribeMode = !isMetaFlow && isSubscribedPouchesMode;
      var shouldForceFallbackCompare = !isMetaFlow
        && (selectedHandleForFallback === STARTER_HANDLE
          || selectedHandleForFallback === POUCH_45_HANDLE
          || selectedHandleForFallback === REFILL_SUBSCRIBE_HANDLE);
      if (isStandardSubscribeMode) {
        var anchorCompare = standardSubscribeCompareFromAnchor(unitPrice);
        if (anchorCompare > unitPrice) compareFallback = anchorCompare;
      }
      if (shouldForceFallbackCompare && compareFallback > unitPrice) {
        comparePrice = compareFallback;
      } else if (comparePrice <= unitPrice && compareFallback > unitPrice) {
        comparePrice = compareFallback;
      }

      state.selectedOneTimePrice = unitPrice;
      state.selectedCompareAtPrice = comparePrice;

      if (subscriptionPriceValueEl && isSubscribedPouchesMode) {
        subscriptionPriceValueEl.textContent = formatMoney(unitPrice);
      }
    }

    function activeHandleForMode() {
      if (isMetaSimpleMode) {
        return state.selectedHandle || pouch45Handle;
      }
      if (state.activeTab === 'starter') return starterHandle;
      if (state.activeTab === 'pouches' && state.isSubscribed) return refillSubscribeHandle;
      return pouch45Handle;
    }

    function refreshVisibleCardFromState() {
      if (isMetaSimpleMode) return;
      var activeCard = cards.find(function (card) {
        return !card.classList.contains('is-hidden');
      });
      if (!activeCard) return;
      var activeHandle = activeHandleForMode();
      var product = state.products[activeHandle];
      if (!product) return;
      var variant = firstAvailableVariant(product);
      if (!variant) return;

      var cardTitle = activeCard.querySelector('[data-card-title]');
      var cardPrice = activeCard.querySelector('[data-card-price]');
      var cardDesc = activeCard.querySelector('[data-card-desc]');
      var cardImage = activeCard.querySelector('[data-card-image]');
      var description = toShortText(stripHtml(product.description), 90);
      var imageUrl = productPrimaryImage(product, 160);

      if (cardTitle) cardTitle.textContent = productDisplayTitle(product);
      if (cardPrice) {
        var priceValue = Number(state.selectedOneTimePrice || variant.price || 0);
        var compareValue = Number(state.selectedCompareAtPrice || variant.compare_at_price || 0);
        renderCardPrice(cardPrice, activeHandle, priceValue, compareValue);
      }
      if (cardDesc) cardDesc.textContent = description;
      if (cardImage && imageUrl) {
        cardImage.src = imageUrl;
        cardImage.alt = productDisplayTitle(product);
        cardImage.loading = 'eager';
        cardImage.fetchPriority = 'high';
        cardImage.decoding = 'async';
      }
    }

    function syncMetaStickyBar() {
      if (!isMetaSimpleMode || !metaStickyEl) return;
      var selectedProduct = state.products[state.selectedHandle];
      if (metaStickyLabelEl && selectedProduct) {
        metaStickyLabelEl.textContent = productDisplayTitle(selectedProduct) || 'Selected option';
      }
      if (metaStickyPriceEl) {
        if (shouldShowHkDistributorMessage(state.selectedHandle)) {
          metaStickyPriceEl.textContent = '';
        } else {
          metaStickyPriceEl.textContent = formatMoney(Number(state.selectedOneTimePrice || 0));
        }
      }
    }

    function selectedQty() {
      var normalized = clampQtyValue((qtyInput && qtyInput.value) || '1');
      if (qtyInput && qtyInput.value !== String(normalized)) {
        qtyInput.value = String(normalized);
      }
      return normalized;
    }

    function syncDiscountBadgeDensity() {
      if (!discountBadgeEl) return;
      var text = String(discountBadgeEl.textContent || '').trim();
      discountBadgeEl.classList.remove('is-long', 'is-xlong');
      if (purchasePriceRowEl) {
        purchasePriceRowEl.classList.remove('is-break-row', 'is-amount-long');
      }
      if (!text) return;

      if (text.length >= 34) {
        discountBadgeEl.classList.add('is-xlong');
      } else if (text.length >= 26) {
        discountBadgeEl.classList.add('is-long');
      }

      // Keep badge inline until price + compare crosses 55% of row width.
      if (!purchasePriceRowEl || !activePriceEl) return;
      var rowWidth = purchasePriceRowEl.getBoundingClientRect().width || purchasePriceRowEl.clientWidth || 0;
      if (rowWidth <= 0) return;
      var currentWidth = activePriceEl.getBoundingClientRect().width || activePriceEl.offsetWidth || 0;
      var compareWidth = 0;
      if (comparePriceEl && !comparePriceEl.hidden) {
        compareWidth = comparePriceEl.getBoundingClientRect().width || comparePriceEl.offsetWidth || 0;
      }
      var combinedPriceWidth = currentWidth + compareWidth;
      var amountTextLen = String(activePriceEl.textContent || '').length
        + ((comparePriceEl && !comparePriceEl.hidden) ? String(comparePriceEl.textContent || '').length : 0);

      if (amountTextLen >= 18) {
        purchasePriceRowEl.classList.add('is-amount-long');
      }

      // Badge should only drop to next line when the amount block itself crosses 55% of row width.
      // Keep a tiny pixel tolerance to avoid jitter from sub-pixel rounding on mobile/landscape.
      if (combinedPriceWidth > ((rowWidth * 0.55) + 4)) {
        purchasePriceRowEl.classList.add('is-break-row');
      }
    }

    function scheduleBadgeLayoutSync() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(syncDiscountBadgeDensity);
      });
    }

    function starterUpsellUnitPrice() {
      var upsellProduct = state.products[starterUpsellHandle];
      var upsellVariant = firstAvailableVariant(upsellProduct);
      return Number((upsellVariant && upsellVariant.price) || 0);
    }

    function starterUpsellComparePrice() {
      var upsellProduct = state.products[starterUpsellHandle];
      var upsellVariant = firstAvailableVariant(upsellProduct);
      var unitPrice = Number((upsellVariant && upsellVariant.price) || 0);
      var comparePrice = Number((upsellVariant && upsellVariant.compare_at_price) || 0);
      if (comparePrice > unitPrice) return comparePrice;

      var fallbackPercent = marketingFallbackPercent(starterUpsellHandle, isMetaFlow, false);
      var fallbackCompare = fallbackCompareFromPercent(unitPrice, fallbackPercent);
      return fallbackCompare > unitPrice ? fallbackCompare : 0;
    }

    function refreshDisplayedTotals() {
      var qty = selectedQty();
      var isStarterTab = state.activeTab === 'starter';
      var isPouchesTab = state.activeTab === 'pouches';
      var isSubscribedPouches = isPouchesTab && state.isSubscribed;
      var isHkPouchesSelection = shouldShowHkDistributorMessage(state.selectedHandle);
      var currentTotal = 0;
      var compareTotal = 0;

      if (isStarterTab) {
        var starterUnitPrice = Number(state.selectedOneTimePrice || 0);
        var starterUnitCompare = Number(state.selectedCompareAtPrice || 0);
        var includeUpsell = !isHkMarket && starterUpsellCheckboxEl && starterUpsellCheckboxEl.checked;
        var upsellUnitPrice = includeUpsell ? starterUpsellUnitPrice() : 0;
        var upsellUnitCompare = includeUpsell ? starterUpsellComparePrice() : 0;

        currentTotal = (starterUnitPrice * qty) + upsellUnitPrice;

        var starterCompareTotal = starterUnitCompare > starterUnitPrice ? (starterUnitCompare * qty) : 0;
        var upsellCompareTotal = upsellUnitCompare > upsellUnitPrice ? upsellUnitCompare : 0;
        compareTotal = starterCompareTotal + upsellCompareTotal;
      } else if (isSubscribedPouches) {
        currentTotal = state.selectedOneTimePrice * qty;
        compareTotal = state.selectedCompareAtPrice > state.selectedOneTimePrice ? state.selectedCompareAtPrice * qty : 0;
      } else {
        currentTotal = state.selectedOneTimePrice * qty;
        compareTotal = state.selectedCompareAtPrice > state.selectedOneTimePrice ? state.selectedCompareAtPrice * qty : 0;
      }

      if (activePriceEl) {
        if (isHkPouchesSelection) {
          activePriceEl.textContent = '';
        } else {
          activePriceEl.textContent = formatMoney(currentTotal);
        }
      }
      if (comparePriceEl) {
        comparePriceEl.hidden = isHkPouchesSelection || !(compareTotal > 0);
        comparePriceEl.textContent = (!isHkPouchesSelection && compareTotal > 0) ? formatMoney(compareTotal) : '';
      }
      if (discountBadgeEl) {
        var badgeOff = compareTotal > 0 ? percentOff(currentTotal, compareTotal) : 0;
        var amountSaved = compareTotal > currentTotal ? (compareTotal - currentTotal) : 0;
        var includeUpsell = !!(!isHkMarket && starterUpsellCheckboxEl && starterUpsellCheckboxEl.checked);

        // Keep Starter savings messaging anchored to Starter % deal even if upsell is selected,
        // but include upsell savings in the SAVE amount.
        if (isStarterTab && includeUpsell) {
          var starterUnitPriceForBadge = Number(state.selectedOneTimePrice || 0);
          var starterUnitCompareForBadge = Number(state.selectedCompareAtPrice || 0);
          if (starterUnitCompareForBadge > starterUnitPriceForBadge) {
            badgeOff = percentOff(starterUnitPriceForBadge, starterUnitCompareForBadge);
            amountSaved = (starterUnitCompareForBadge - starterUnitPriceForBadge) * qty;
          }

          var upsellUnitPriceForBadge = starterUpsellUnitPrice();
          var upsellUnitCompareForBadge = starterUpsellComparePrice();
          if (upsellUnitCompareForBadge > upsellUnitPriceForBadge) {
            amountSaved += (upsellUnitCompareForBadge - upsellUnitPriceForBadge);
          }
        }

        discountBadgeEl.hidden = isHkPouchesSelection || !(badgeOff > 0);
        discountBadgeEl.textContent = (!isHkPouchesSelection && badgeOff > 0)
          ? ('HOT DEAL • ' + badgeOff + '% OFF • SAVE ' + formatMoney(amountSaved))
          : '';
        if (!isHkPouchesSelection && badgeOff > 0) {
          discountBadgeEl.setAttribute('title', badgeOff + '% OFF');
          discountBadgeEl.setAttribute('aria-label', badgeOff + '% off');
        } else {
          discountBadgeEl.removeAttribute('title');
          discountBadgeEl.removeAttribute('aria-label');
        }
        scheduleBadgeLayoutSync();
      }
      maybeShowCrazySalePopup(compareTotal > currentTotal);
      if (priceEl) {
        if (isHkPouchesSelection) {
          priceEl.textContent = '';
        } else {
          priceEl.textContent = formatMoney(currentTotal);
        }
      }
      if (usFreeShippingEl) {
        var freeShippingThresholdCents = 7001; // over $70
        var remainingForFreeShipping = freeShippingThresholdCents - Number(currentTotal || 0);
        var progressPercent = Math.max(0, Math.min(100, (Number(currentTotal || 0) / freeShippingThresholdCents) * 100));
        usFreeShippingEl.style.setProperty('--haro-progress', String(progressPercent));
        var usShippingLabelEl = usFreeShippingEl.querySelector('[data-mega-us-free-shipping-label]');
        if (remainingForFreeShipping > 0) {
          usFreeShippingEl.classList.remove('is-qualified');
          var unlockText = 'Free US shipping over $70 — add ' + formatMoney(remainingForFreeShipping) + ' more.';
          if (usShippingLabelEl) {
            usShippingLabelEl.textContent = unlockText;
          } else {
            usFreeShippingEl.textContent = unlockText;
          }
        } else {
          usFreeShippingEl.classList.add('is-qualified');
          if (usShippingLabelEl) {
            usShippingLabelEl.textContent = '🎉 Free shipping unlocked! Your order qualifies for free US delivery.';
          } else {
            usFreeShippingEl.textContent = '🎉 Free shipping unlocked! Your order qualifies for free US delivery.';
          }
        }
      }
      scrubLegacyHkDistributorCopy();
      refreshStaticCurrencyCopy();
    }

    function refreshStaticCurrencyCopy() {
      function deriveUsdToPresentmentRate() {
        var activeHandle = state.selectedHandle;
        var activeUsdCents = Number(USD_CENTS_BY_HANDLE[activeHandle] || 0);
        var activeLocalCents = Number(state.selectedOneTimePrice || 0);
        if (activeUsdCents > 0 && activeLocalCents > 0) {
          var activeRate = activeLocalCents / activeUsdCents;
          if (Number.isFinite(activeRate) && activeRate > 0) return activeRate;
        }

        var candidateHandles = [
          starterHandle,
          pouch45Handle,
          refillSubscribeHandle,
          starterUpsellHandle
        ];

        for (var i = 0; i < candidateHandles.length; i += 1) {
          var handle = candidateHandles[i];
          var usdCents = Number(USD_CENTS_BY_HANDLE[handle] || 0);
          if (!usdCents) continue;
          var product = state.products[handle];
          var variant = firstAvailableVariant(product);
          var localCents = Number(variant && variant.price || 0);
          if (localCents > 0) {
            var rate = localCents / usdCents;
            if (Number.isFinite(rate) && rate > 0) return rate;
          }
        }

        return 1;
      }

      if (subscriptionPriceValueEl && state.activeTab === 'pouches' && state.isSubscribed) {
        subscriptionPriceValueEl.textContent = formatMoney(Number(state.selectedOneTimePrice || 0));
      }

      if (giftValueEls && giftValueEls.length) {
        var usdToPresentmentRate = deriveUsdToPresentmentRate();
        giftValueEls.forEach(function (el) {
          var usdCents = Number(el.getAttribute('data-gift-cents') || 0);
          var presentmentCents = Math.round(usdCents * usdToPresentmentRate);
          el.textContent = formatMoneyWhole(presentmentCents) + ' value';
        });
      }
    }

    function isSalePopupSeen() {
      if (isMetaVisitor) return false;
      try {
        return window.sessionStorage.getItem(CRAZY_SALE_POPUP_SESSION_KEY) === '1';
      } catch (error) {
        return false;
      }
    }

    function markSalePopupSeen() {
      if (isMetaVisitor) return;
      try {
        window.sessionStorage.setItem(CRAZY_SALE_POPUP_SESSION_KEY, '1');
      } catch (error) {}
    }

    function isSalePopupDismissedForNow() {
      try {
        var raw = window.localStorage.getItem(CRAZY_SALE_POPUP_DISMISS_UNTIL_KEY);
        var until = Number(raw || 0);
        if (!Number.isFinite(until) || until <= 0) return false;
        if (Date.now() < until) return true;
        window.localStorage.removeItem(CRAZY_SALE_POPUP_DISMISS_UNTIL_KEY);
        return false;
      } catch (error) {
        return false;
      }
    }

    function markSalePopupDismissedFor48h() {
      try {
        var fortyEightHoursMs = 48 * 60 * 60 * 1000;
        window.localStorage.setItem(
          CRAZY_SALE_POPUP_DISMISS_UNTIL_KEY,
          String(Date.now() + fortyEightHoursMs)
        );
      } catch (error) {}
    }

    function clearSalePopupCountdown() {
      if (salePopupCountdownTimer) {
        window.clearInterval(salePopupCountdownTimer);
        salePopupCountdownTimer = null;
      }
      if (salePopupAutoMinimizeTimer) {
        window.clearTimeout(salePopupAutoMinimizeTimer);
        salePopupAutoMinimizeTimer = null;
      }
      if (salePopupEl) {
        salePopupEl.classList.remove('is-closing');
      }
    }

    function updateSalePopupCountdownText() {
      if (!salePopupCountdownEl) return;
      var seconds = Math.max(0, Number(salePopupCountdownSeconds || 0));
      salePopupCountdownEl.textContent = seconds > 0
        ? ('Minimizing in ' + seconds)
        : '';
      salePopupCountdownEl.hidden = seconds <= 0;

      if (salePopupCtaEl && salePopupEl && !salePopupEl.classList.contains('is-minimized')) {
        setSalePopupCtaLabel(seconds > 0 ? ('Minimizing in ' + seconds) : '');
      }
    }

    function minimizeCrazySalePopup() {
      if (!salePopupEl || salePopupEl.classList.contains('is-minimized')) return;
      salePopupEl.classList.add('is-minimized');
      salePopupEl.classList.remove('is-open');
      salePopupEl.classList.add('is-mini-bills');
      document.body.classList.remove('haro-sale-popup-open');
      salePopupCountdownSeconds = 0;
      if (salePopupCountdownEl) {
        salePopupCountdownEl.hidden = false;
        salePopupCountdownEl.textContent = '';
      }
      if (salePopupCtaEl) {
        setSalePopupCtaLabel('');
      }
      clearSalePopupCountdown();
    }

    function startSalePopupCountdown() {
      clearSalePopupCountdown();
      salePopupCountdownSeconds = CRAZY_SALE_POPUP_COUNTDOWN_SECONDS;
      updateSalePopupCountdownText();
      salePopupCountdownTimer = window.setInterval(function () {
        salePopupCountdownSeconds -= 1;
        if (salePopupCountdownSeconds <= 0) {
          clearSalePopupCountdown();
          if (salePopupCountdownEl) {
            salePopupCountdownEl.textContent = 'Minimizing...';
            salePopupCountdownEl.hidden = false;
          }
          if (salePopupCtaEl && salePopupEl && !salePopupEl.classList.contains('is-minimized')) {
            setSalePopupCtaLabel('Minimizing...');
          }
          if (salePopupEl) {
            salePopupEl.classList.add('is-closing');
          }
          salePopupAutoMinimizeTimer = window.setTimeout(function () {
            if (salePopupEl) {
              salePopupEl.classList.remove('is-closing');
            }
            minimizeCrazySalePopup();
          }, 850);
          return;
        }
        updateSalePopupCountdownText();
      }, 1000);
    }

    function closeCrazySalePopup() {
      minimizeCrazySalePopup();
    }

    function hardCloseCrazySalePopup() {
      if (!salePopupEl) return;
      clearSalePopupCountdown();
      salePopupEl.hidden = true;
      salePopupEl.classList.remove('is-open');
      salePopupEl.classList.remove('is-minimized');
      salePopupEl.classList.remove('is-mini-bills');
      salePopupEl.classList.remove('is-closing');
      document.body.classList.remove('haro-sale-popup-open');
      if (salePopupCtaEl) {
        setSalePopupCtaLabel('');
      }
      markSalePopupDismissedFor48h();
      markSalePopupSeen();
    }

    function openCrazySalePopup(options) {
      if (!salePopupEl) return;
      var withCountdown = !(options && options.withCountdown === false);
      salePopupEl.hidden = false;
      salePopupEl.classList.remove('is-minimized');
      salePopupEl.classList.remove('is-mini-bills');
      salePopupEl.classList.add('is-open');
      document.body.classList.add('haro-sale-popup-open');
      if (salePopupCtaEl) {
        setSalePopupCtaLabel('');
      }
      if (withCountdown) {
        startSalePopupCountdown();
      } else {
        clearSalePopupCountdown();
        salePopupCountdownSeconds = 0;
        updateSalePopupCountdownText();
      }
    }

    function maybeShowCrazySalePopup(hasDiscount) {
      if (!salePopupEl || hasAttemptedPopupShow) return;
      if (!isMetaVisitor) return;
      if (isSalePopupDismissedForNow()) return;
      if (!hasDiscount) return;
      hasAttemptedPopupShow = true;
      window.setTimeout(function () {
        openCrazySalePopup({ withCountdown: true });
      }, 250);
    }

    function syncPurchaseUi() {
      if (!purchaseOptionsEl) return;
      purchaseOptionsEl.hidden = false;

      if (isMetaSimpleMode) {
        state.activeTab = 'meta';
        state.isSubscribed = false;
        if (refillSubscribeCheckboxEl) refillSubscribeCheckboxEl.checked = false;
        if (starterOneTimeNoteEl) starterOneTimeNoteEl.hidden = true;
        if (starterUpsellWrapEl) starterUpsellWrapEl.hidden = true;
        if (giftsEl) giftsEl.hidden = true;
        if (refillSubscribeWrapEl) refillSubscribeWrapEl.hidden = true;
        if (subscriptionDetailsEl) subscriptionDetailsEl.hidden = true;
        setSubscriptionDetailsExpanded(false);

        var selectedVariant = findSelectedVariantData();
        var selectedProduct = state.products[state.selectedHandle];
        if (selectedVariant && selectedVariant.requires_selling_plan) {
          state.selectedSellingPlanId = firstSellingPlanIdForVariant(selectedVariant, selectedProduct);
        } else {
          state.selectedSellingPlanId = null;
        }
        if (sellingPlanInputEl) sellingPlanInputEl.value = state.selectedSellingPlanId || '';

        refreshSelectedPricesForMode();
        refreshDisplayedTotals();
        syncMetaStickyBar();
        var isHkBlockedMeta = shouldShowHkDistributorMessage(state.selectedHandle);
        syncHkPouchMessage(isHkBlockedMeta);
        syncHkPouchDisabledUi(isHkBlockedMeta);

        if (atcButton) {
          var cannotAddMeta = isHkBlockedMeta
            || !state.selectedVariantId
            || (state.selectedRequiresSellingPlan && !state.selectedSellingPlanId);
          atcButton.disabled = cannotAddMeta;
          atcButton.setAttribute('aria-disabled', cannotAddMeta ? 'true' : 'false');
        }
        return;
      }

      var isStarterTab = state.activeTab === 'starter';
      var isPouchesTab = state.activeTab === 'pouches';
      var isHkPouchesTab = isHkMarket && isPouchesTab;

      if (starterOneTimeNoteEl) starterOneTimeNoteEl.hidden = !isStarterTab;
      if (starterUpsellWrapEl) starterUpsellWrapEl.hidden = !isStarterTab || isHkMarket;
      if (isHkMarket && starterUpsellCheckboxEl) starterUpsellCheckboxEl.checked = false;
      if (giftsEl) giftsEl.hidden = !isStarterTab;
      if (refillSubscribeWrapEl) refillSubscribeWrapEl.hidden = !isPouchesTab || isHkPouchesTab;

      if (!isPouchesTab || isHkPouchesTab) {
        state.isSubscribed = false;
        if (refillSubscribeCheckboxEl) refillSubscribeCheckboxEl.checked = false;
      }

      if (isStarterTab) {
        state.selectedSellingPlanId = null;
        if (sellingPlanInputEl) sellingPlanInputEl.value = '';
        if (subscriptionDetailsEl) subscriptionDetailsEl.hidden = true;
        setSubscriptionDetailsExpanded(false);
      }

      if (isPouchesTab) {
        if (state.isSubscribed) {
          var selectedVariant = findSelectedVariantData();
          var selectedProduct = state.products[state.selectedHandle];
          state.selectedSellingPlanId = firstSellingPlanIdForVariant(selectedVariant, selectedProduct);
          if (sellingPlanInputEl) sellingPlanInputEl.value = state.selectedSellingPlanId || '';

          if (subscriptionDetailsEl) {
            subscriptionDetailsEl.hidden = false;
            window.requestAnimationFrame(refreshSubscriptionDetailsOverflow);
          }
        } else {
          state.selectedSellingPlanId = null;
          if (sellingPlanInputEl) sellingPlanInputEl.value = '';

          if (subscriptionDetailsEl) subscriptionDetailsEl.hidden = true;
          setSubscriptionDetailsExpanded(false);
        }
      }

      refreshSelectedPricesForMode();

      refreshVisibleCardFromState();
      refreshDisplayedTotals();
      syncMetaStickyBar();
      var isHkBlocked = shouldShowHkDistributorMessage(state.selectedHandle);
      syncHkPouchMessage(isHkBlocked);
      syncHkPouchDisabledUi(isHkBlocked);
      scrubLegacyHkDistributorCopy();

      if (atcButton) {
        var cannotAdd = isHkBlocked
          || !state.selectedVariantId
          || (isPouchesTab && state.isSubscribed && !state.selectedSellingPlanId);
        atcButton.disabled = cannotAdd;
        atcButton.setAttribute('aria-disabled', cannotAdd ? 'true' : 'false');
      }
    }

    function selectCard(cardEl) {
      if (!cardEl) return;
      var handle = isMetaSimpleMode
        ? (cardEl.dataset.productHandle || '')
        : activeHandleForMode();
      var product = state.products[handle];
      if (!product) return;
      var variant = firstAvailableVariant(product);
      if (!variant) return;

      state.selectedHandle = handle;
      state.selectedVariantId = String(variant.id);
      state.selectedRequiresSellingPlan = !!variant.requires_selling_plan;
      state.selectedOneTimePrice = Number(variant.price || 0);
      state.selectedCompareAtPrice = Number(variant.compare_at_price || 0);

      var selectableCards = cards.filter(function (card) {
        if (isMetaSimpleMode) return true;
        return !card.classList.contains('is-hidden');
      });
      selectableCards.forEach(function (card) {
        card.classList.toggle('is-selected', card === cardEl);
      });

      if (titleEl) titleEl.textContent = productDisplayTitle(product);
      if (subtitleEl) subtitleEl.textContent = toShortText(stripHtml(product.description), 120);
      if (merchantPrimaryTitleEl) merchantPrimaryTitleEl.textContent = productDisplayTitle(product);
      if (merchantPrimaryPriceEl) {
        merchantPrimaryPriceEl.textContent = shouldShowHkDistributorMessage(handle) ? '' : formatMoney(Number(variant.price || 0));
      }
      if (merchantPrimaryAvailabilityEl) {
        merchantPrimaryAvailabilityEl.textContent = shouldShowHkDistributorMessage(handle)
          ? 'Contact local distributor'
          : (variant.available ? 'In stock' : 'Out of stock');
      }

      var imageUrl = productPrimaryImage(product, 220);
      if (imageEl) {
        imageEl.src = imageUrl;
        imageEl.alt = productDisplayTitle(product);
      }
      syncMainProductGallery(root, product);

      syncPurchaseUi();
      syncMetaStickyBar();
    }

    function setTab(tabKey) {
      if (isMetaSimpleMode) {
        var firstCard = cards[0];
        if (firstCard) selectCard(firstCard);
        return;
      }
      state.activeTab = tabKey;
      if (tabKey === 'starter' || (isHkMarket && tabKey === 'pouches')) {
        state.isSubscribed = false;
      }

      tabButtons.forEach(function (btn) {
        var active = btn.dataset.megaTab === tabKey;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      cards.forEach(function (card) {
        var visible = card.dataset.productKind === tabKey;
        card.classList.toggle('is-hidden', !visible);
      });

      var firstVisible = cards.find(function (card) { return !card.classList.contains('is-hidden'); });
      if (firstVisible) selectCard(firstVisible);

      if (debugEnabled()) {
        var activeHandle = firstVisible ? firstVisible.dataset.productHandle : '';
        console.debug('[HARO_MEGA_PDP] tab switch', { tab: tabKey, activeHandle: activeHandle });
      }
    }

    function addToCart() {
      if (!state.selectedVariantId) return;
      if (shouldShowHkDistributorMessage(state.selectedHandle)) return;

      var isPouchesSubscription = !isMetaSimpleMode && state.activeTab === 'pouches' && state.isSubscribed;
      var qty = selectedQty();

      var items = [];
      var selectedVariantNumericId = Number(state.selectedVariantId);
      if (isPouchesSubscription) {
        var selectedPlanNumericId = Number(state.selectedSellingPlanId || 0);
        if (!selectedVariantNumericId || !selectedPlanNumericId) {
          window.alert('Subscription is not configured for this refill variant yet. Please attach a selling plan to this variant in Shopify admin.');
          if (debugEnabled()) {
            console.warn('[HARO_MEGA_PDP] missing selected variant selling plan', {
              variantId: selectedVariantNumericId,
              sellingPlanId: selectedPlanNumericId
            });
          }
          return;
        }

        items.push({
          id: selectedVariantNumericId,
          quantity: qty,
          selling_plan: selectedPlanNumericId,
          properties: {
            _refill_subscription_intent: 'true',
            _refill_subscription_bundle: '2_pouches_90_days',
            _refill_subscription_bundle_count: String(qty),
            _refill_subscription_total_pouches: String(qty * 2)
          }
        });
      } else {
        var item = {
          id: Number(state.selectedVariantId),
          quantity: qty
        };
        if (state.selectedSellingPlanId) {
          item.selling_plan = Number(state.selectedSellingPlanId);
        }
        items.push(item);
      }

      if (!isMetaSimpleMode && !isHkMarket && state.activeTab === 'starter' && starterUpsellCheckboxEl && starterUpsellCheckboxEl.checked) {
        var upsellProduct = state.products[starterUpsellHandle];
        var upsellVariant = firstAvailableVariant(upsellProduct);
        if (upsellVariant && upsellVariant.id) {
          items.push({
            id: Number(upsellVariant.id),
            quantity: 1,
            properties: {
              _starter_upsell: 'true'
            }
          });
        }
      }

      if (debugEnabled()) {
        console.debug('[HARO_MEGA_PDP] add payload', {
          handle: state.selectedHandle,
          activeTab: state.activeTab,
          isSubscribed: state.isSubscribed,
          items: items
        });
      }
      debugSubscription('cart add payload', {
        handle: state.selectedHandle,
        activeTab: state.activeTab,
        isSubscribed: state.isSubscribed,
        items: items
      });

      atcButton.disabled = true;
      getCartJsonSafe()
        .then(function (cartBeforeAdd) {
          var currentCount = cartItemCount(cartBeforeAdd);
          var incomingCount = items.reduce(function (total, item) {
            return total + Math.max(0, Number(item && item.quantity || 0));
          }, 0);
          var nextCount = currentCount + incomingCount;
          if (nextCount > MAX_QTY) {
            var remaining = Math.max(0, MAX_QTY - currentCount);
            var friendlyMessage = remaining > 0
              ? 'Carts are maxed at 40 items. You can add up to ' + remaining + ' more item' + (remaining === 1 ? '' : 's') + '.'
              : MAX_CART_TOOLTIP_TEXT;
            showQtyLimitTooltip(friendlyMessage);
            throw new Error(friendlyMessage);
          }

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(parseJsonResponseSafe)
        .then(function (response) {
          debugSubscription('cart add response', response);
          return getCartJsonSafe()
            .catch(function (error) {
              if (debugEnabled()) {
                console.warn('[HARO_MEGA_PDP] cart.js refresh failed', error);
              }
              return null;
            })
            .then(function (cart) {
              debugSubscription('cart.js snapshot', cart);
              if (cart && typeof cart.item_count !== 'undefined') {
                document.dispatchEvent(
                  new CustomEvent('theme:cart:change', {
                    bubbles: true,
                    detail: {
                      cartCount: cart.item_count,
                      cart: cart
                    }
                  })
                );
              }

              document.dispatchEvent(
                new CustomEvent('theme:cart:refresh', {
                  bubbles: true,
                  detail: {
                    source: 'haro-mega-pdp',
                    cart: cart,
                    response: response
                  }
                })
              );

              var hasDrawer = window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer' && document.querySelector('cart-drawer');
              if (hasDrawer) {
                document.dispatchEvent(
                  new CustomEvent('theme:product:added', {
                    bubbles: true,
                    detail: {
                      source: 'haro-mega-pdp',
                      cart: cart,
                      response: response
                    }
                  })
                );

                var cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
                }
              } else {
                window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
              }
            });
        })
        .catch(function (primaryError) {
          debugSubscription('cart add error', {
            message: primaryError && primaryError.message ? primaryError.message : String(primaryError || '')
          });
          window.alert((primaryError && primaryError.message) ? primaryError.message : 'Unable to add this subscription to cart. Please try again.');
          if (debugEnabled()) {
            console.error('[HARO_MEGA_PDP] add error', primaryError);
          }
        })
        .finally(function () {
          atcButton.disabled = false;
          syncPurchaseUi();
        });
    }

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTab(btn.dataset.megaTab);
      });
    });

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectCard(card);
      });
    });

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var next = clampQtyValue((parseInt(qtyInput.value || '1', 10) || 1) - 1);
        qtyInput.value = String(next);
        syncPurchaseUi();
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var current = clampQtyValue(parseInt(qtyInput.value || '1', 10) || 1);
        if (current >= MAX_QTY) {
          qtyInput.value = String(MAX_QTY);
          showQtyLimitTooltip();
          syncPurchaseUi();
          return;
        }
        var next = clampQtyValue(current + 1);
        qtyInput.value = String(next);
        syncPurchaseUi();
      });
    }

    if (qtyInput) {
      qtyInput.setAttribute('max', String(MAX_QTY));
      qtyInput.addEventListener('input', function () {
        var rawParsed = parseInt(qtyInput.value || '1', 10);
        if (Number.isFinite(rawParsed) && rawParsed > MAX_QTY) {
          showQtyLimitTooltip();
        }
        var normalized = clampQtyValue(qtyInput.value || '1');
        qtyInput.value = String(normalized);
        syncPurchaseUi();
      });
    }

    if (atcButton) {
      atcButton.addEventListener('click', addToCart);
    }

    if (metaStickyAtcEl && atcButton) {
      metaStickyAtcEl.addEventListener('click', function () {
        atcButton.click();
      });
    }

    if (subscriptionDetailsToggleEl) {
      subscriptionDetailsToggleEl.addEventListener('click', function () {
        var isExpanded = subscriptionDetailsContentEl && subscriptionDetailsContentEl.classList.contains('is-expanded');
        setSubscriptionDetailsExpanded(!isExpanded);
      });
    }

    if (starterUpsellCheckboxEl) {
      starterUpsellCheckboxEl.addEventListener('change', function () {
        syncPurchaseUi();
      });
    }

    if (goRefillLinkEl) {
      goRefillLinkEl.addEventListener('click', function (event) {
        event.preventDefault();
        if (isMetaSimpleMode) {
          var pouchCard = cards.find(function (card) {
            return card.dataset.productHandle === pouch45Handle;
          });
          if (pouchCard) {
            selectCard(pouchCard);
          }
          return;
        }
        setTab('pouches');
      });
    }

    if (!isMetaSimpleMode && !isHkMarket && refillSubscribeRowEl && refillSubscribeCheckboxEl) {
      refillSubscribeRowEl.addEventListener('click', function (event) {
        if (event.target === refillSubscribeCheckboxEl) return;
        event.preventDefault();
        refillSubscribeCheckboxEl.checked = !refillSubscribeCheckboxEl.checked;
        refillSubscribeCheckboxEl.dispatchEvent(new Event('change', { bubbles: true }));
      });

      refillSubscribeCheckboxEl.addEventListener('change', function () {
        state.isSubscribed = !!refillSubscribeCheckboxEl.checked;
        var activeCard = cards.find(function (card) {
          return !card.classList.contains('is-hidden');
        });
        if (activeCard) {
          selectCard(activeCard);
        } else {
          syncPurchaseUi();
        }
      });
    }

    if (salePopupCloseEls.length) {
      salePopupCloseEls.forEach(function (el) {
        el.addEventListener('click', function (event) {
          event.preventDefault();
          var isCloseIcon = !!(event.currentTarget && event.currentTarget.classList && event.currentTarget.classList.contains('haro-sale-popup__close'));
          if (isCloseIcon && salePopupEl && salePopupEl.classList.contains('is-minimized')) {
            hardCloseCrazySalePopup();
            return;
          }
          minimizeCrazySalePopup();
        });
      });
    }

    if (salePopupCtaEl) {
      salePopupCtaEl.addEventListener('click', function (event) {
        event.preventDefault();
        if (salePopupEl && !salePopupEl.classList.contains('is-minimized')) {
          minimizeCrazySalePopup();
        }
        if (atcButton && typeof atcButton.scrollIntoView === 'function') {
          window.setTimeout(function () {
            atcButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 30);
        }
      });
    }

    if (salePopupEl) {
      salePopupEl.addEventListener('click', function (event) {
        if (!salePopupEl.classList.contains('is-minimized')) return;
        if (event.target && event.target.closest('[data-mega-sale-popup-close]')) return;
        if (event.target && event.target.closest('[data-mega-sale-popup-cta]')) return;
        openCrazySalePopup({ withCountdown: true });
      });
    }

    if (salePopupGifEl) {
      salePopupGifEl.addEventListener('error', function () {
        salePopupGifEl.src = 'https://media.giphy.com/media/xT0xezQGU5xCDJuCPe/giphy.gif';
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && salePopupEl && !salePopupEl.hidden) {
        minimizeCrazySalePopup();
      }
    });

    var handles = Array.prototype.slice
      .call(root.querySelectorAll('[data-mega-card="true"][data-product-handle]'))
      .map(function (card) { return card.dataset.productHandle; })
      .concat([starterHandle, pouch45Handle, refillSubscribeHandle])
      .filter(function (handle, index, arr) { return !!handle && arr.indexOf(handle) === index; });

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) { return res.json(); })
          .then(function (json) {
            state.products[handle] = json;
          });
      })
    ).then(function () {
      [starterHandle, pouch45Handle, refillSubscribeHandle].forEach(function (handle) {
        var product = state.products[handle];
        preloadImage(productPrimaryImage(product, 160));
      });

      cards = cards.filter(function (card) {
        var isValid = hydrateCard(card);
        if (!isValid) {
          card.remove();
        }
        return isValid;
      });

      if (!cards.length) return;

      if (isMetaSimpleMode) {
        var initialHandle = root.dataset.initialHandle || '';
        var initialCard = cards.find(function (card) {
          return card.dataset.productHandle === initialHandle;
        }) || cards.find(function (card) {
          return card.classList.contains('is-selected');
        }) || cards[0];
        selectCard(initialCard);
      } else {
        var initialSelection = getInitialSelectionFromUrl(root.dataset.initialTab);
        if (isMetaFlow && !initialSelection.hasTabOverride) {
          initialSelection.tab = 'pouches';
        }
        if (isHkMarket) {
          initialSelection.subscribe = false;
        }
        setTab(initialSelection.tab);

        if (initialSelection.tab === 'pouches' && refillSubscribeCheckboxEl) {
          refillSubscribeCheckboxEl.checked = !!initialSelection.subscribe;
          state.isSubscribed = !!initialSelection.subscribe;

          var activeCard = cards.find(function (card) {
            return !card.classList.contains('is-hidden');
          });
          if (activeCard) {
            selectCard(activeCard);
          } else {
            syncPurchaseUi();
          }
        }
      }

      window.__HARO_MEGA = {
        get selectedHandle() {
          return state.selectedHandle;
        },
        get selectedVariantId() {
          return state.selectedVariantId;
        },
        get activeTab() {
          return state.activeTab;
        },
        get isSubscribed() {
          return state.isSubscribed;
        }
      };
    });

    function scheduleResponsiveReflow() {
      window.requestAnimationFrame(function () {
        scheduleBadgeLayoutSync();
        if (subscriptionDetailsEl && !subscriptionDetailsEl.hidden) {
          refreshSubscriptionDetailsOverflow();
        }
      });
    }

    window.addEventListener('resize', scheduleResponsiveReflow);
    window.addEventListener('orientationchange', function () {
      window.setTimeout(scheduleResponsiveReflow, 90);
    });
    window.setTimeout(scheduleResponsiveReflow, 120);
  }

  function boot() {
    document.querySelectorAll('[data-haro-mega-pdp]').forEach(initMegaPdp);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('theme:product-info:loaded', boot);
  document.addEventListener('shopify:section:load', boot);

  if (document.readyState !== 'loading') boot();
})();
